"use strict";

var _assign = function __assign() {
  return (_assign = Object.assign || function (o) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      for (var s in t = arguments[r]) {
        Object.prototype.hasOwnProperty.call(t, s) && (o[s] = t[s]);
      }
    }

    return o;
  }).apply(this, arguments);
},
    mapPartialCoords = (Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.mapPositionCoords = exports.mapPartialCoords = void 0, function (o) {
  return o.map(function (o) {
    return {
      width: o.width,
      position: 0
    };
  });
}),
    mapPositionCoords = (exports.mapPartialCoords = mapPartialCoords, function (o, t) {
  return void 0 === t && (t = 0), o.map(function (o) {
    return o.position > t ? _assign(_assign({}, o), {
      position: t
    }) : o;
  });
});

exports.mapPositionCoords = mapPositionCoords;